import { motion } from "framer-motion";
import { COMPARISON_OPTIONS, COMPARISON_DIMENSIONS } from "@/data/content";

const isHybrid = (index) => COMPARISON_OPTIONS[index] === "Hybrid Microgrid";

export const CompetitiveMatrix = () => (
  <section data-testid="comparison-section" className="bg-surfaceLight px-6 py-[30px] sm:py-[40px] lg:px-12 lg:pt-[40px] lg:pb-[70px]">
    <div className="lg:mx-auto lg:max-w-[1280px]">
      <div className="mb-4 max-w-2xl lg:mx-auto lg:text-center">
        <h2 className="font-heading text-[30px] font-semibold leading-tight text-ink sm:text-[35px] lg:text-[41px]">
          Compare the alternatives
        </h2>
        <p className="mt-5 text-[15px] leading-relaxed text-inkSoft">
          Every option involves trade-offs. A hybrid microgrid isn't automatically the right fit for
          every site — a formal assessment determines what makes sense for your operation.
        </p>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.55 }}
        data-testid="comparison-table-container"
        className="mt-10 overflow-x-auto rounded-3xl border border-borderSubtle bg-white"
      >
        <table data-testid="comparison-table" className="w-full min-w-[940px] table-fixed border-collapse text-left">
          <thead>
            <tr className="border-b border-borderSubtle">
              <th className="w-[22%] px-5 py-5 lg:px-6">
                <span className="sr-only">Comparison criteria</span>
              </th>
              {COMPARISON_OPTIONS.map((option, index) => (
                <th
                  key={option}
                  data-testid={`comparison-option-${index}`}
                  scope="col"
                  className={`px-5 py-5 font-heading text-sm font-semibold lg:px-6 ${isHybrid(index) ? "border-l border-teal/15 bg-glacier text-teal" : "text-ink"}`}
                >
                  {option}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {COMPARISON_DIMENSIONS.map((dimension, rowIndex) => (
              <tr key={dimension.label} className={rowIndex !== COMPARISON_DIMENSIONS.length - 1 ? "border-b border-borderLight" : ""}>
                <th
                  data-testid={`comparison-criterion-${rowIndex}`}
                  scope="row"
                  className="px-5 py-6 text-sm font-medium text-inkSoft lg:px-6"
                >
                  {dimension.label}
                </th>
                {dimension.values.map((value, columnIndex) => (
                  <td
                    key={`${dimension.label}-${COMPARISON_OPTIONS[columnIndex]}`}
                    data-testid={`comparison-value-${rowIndex}-${columnIndex}`}
                    className={`px-5 py-6 text-sm leading-relaxed lg:px-6 ${isHybrid(columnIndex) ? "border-l border-teal/15 bg-glacier text-ink" : "text-inkSoft"}`}
                  >
                    {value}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </motion.div>
    </div>
  </section>
);